import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Layout from "./components/Layout";
import ProtectedRoute from "./components/ProtectedRoute";
import Dashboard from "./pages/Dashboard";
import Bookings from "./pages/Bookings";
import CalendarPage from "./pages/Calendar";
import Reports from "./pages/Reports";
import Rooms from "./pages/Rooms";
import Invoice from "./pages/Invoice";
import Settings from "./pages/Settings";
import Login from "./pages/Login";
import Help from "./pages/Help";
import Upgrade from "./pages/Upgrade";
import SuperAdmin from "./pages/SuperAdmin";
import ReportPrint from "./pages/ReportPrint";
import ExpensesPrint from "./pages/ExpensesPrint";
import BookingsPrint from "./pages/BookingsPrint";
import Invoices from "./pages/Invoices";
import InvoicePrint from "./pages/InvoicePrint";
import Reminders from "./pages/Reminders";
import Guests from "./pages/Guests";
import Expenses from "./pages/Expenses";
import Landing from "./pages/Landing";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import { AuthProvider, useAuth } from "./lib/auth";
import { TenantProvider } from "./lib/tenant";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <TenantProvider>
            <Routes>
              <Route path="/" element={<RootRoute />} />
              <Route path="/login" element={<Login />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route
                path="/invoice/:id"
                element={<ProtectedRoute><Invoice /></ProtectedRoute>}
              />
              <Route
                path="/reports/print/:type/:year"
                element={<ProtectedRoute ownerOnly><ReportPrint /></ProtectedRoute>}
              />
              <Route
                path="/reports/print/range/:start/:end"
                element={<ProtectedRoute ownerOnly><ReportPrint /></ProtectedRoute>}
              />
              <Route
                path="/expenses/print/:year/:month"
                element={<ProtectedRoute ownerOnly><ExpensesPrint /></ProtectedRoute>}
              />
              <Route
                path="/expenses/print/:year"
                element={<ProtectedRoute ownerOnly><ExpensesPrint /></ProtectedRoute>}
              />
              <Route
                path="/bookings/print"
                element={<ProtectedRoute><BookingsPrint /></ProtectedRoute>}
              />
              <Route
                path="/invoices"
                element={<ProtectedRoute><Invoices /></ProtectedRoute>}
              />
              <Route
                path="/invoices/:id/print"
                element={<ProtectedRoute><InvoicePrint /></ProtectedRoute>}
              />
              <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/bookings" element={<Bookings />} />
                <Route path="/reminders" element={<Reminders />} />
                <Route path="/guests" element={<ProtectedRoute ownerOnly><Guests /></ProtectedRoute>} />
                <Route path="/expenses" element={<ProtectedRoute ownerOnly><Expenses /></ProtectedRoute>} />
                <Route path="/calendar" element={<CalendarPage />} />
                <Route path="/reports" element={<ProtectedRoute ownerOnly><Reports /></ProtectedRoute>} />
                <Route path="/rooms" element={<Rooms />} />
                <Route path="/settings" element={<ProtectedRoute ownerOnly><Settings /></ProtectedRoute>} />
                <Route path="/help" element={<Help />} />
                <Route path="/upgrade" element={<Upgrade />} />
                <Route path="/admin" element={<ProtectedRoute superAdminOnly><SuperAdmin /></ProtectedRoute>} />
              </Route>
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
            <Toaster position="top-right" richColors />
          </TenantProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

// Root: show landing to guests; redirect logged-in users to dashboard
function RootRoute() {
  const { token } = useAuth();
  if (token) return <Navigate to="/dashboard" replace />;
  return <Landing />;
}

export default App;
